/**
 * USD list prices per paid plan. The billing page swaps in Dodo's price for the chosen currency
 * when it loads; upgrade prompts outside the dashboard show these.
 */
export type UpgradePlanName = 'Starter' | 'Professional' | 'Business';
export type PlanBillingInterval = 'monthly' | 'annual';

export interface PlanListPrice {
  compareAt: number;
  current: number;
  annualTotal?: number;
}

export const PLAN_LIST_PRICING_USD: Record<
  UpgradePlanName,
  Record<PlanBillingInterval, PlanListPrice>
> = {
  Starter: {
    monthly: { compareAt: 29, current: 19 },
    annual: { compareAt: 29, current: 15, annualTotal: 180 },
  },
  Professional: {
    monthly: { compareAt: 59, current: 39 },
    annual: { compareAt: 59, current: 31, annualTotal: 372 },
  },
  Business: {
    monthly: { compareAt: 149, current: 89 },
    annual: { compareAt: 149, current: 71, annualTotal: 852 },
  },
};

/** Whole-percent saving of annual over monthly billing, rounded down so it never overstates. */
export function getAnnualSavingsPercent(plan: UpgradePlanName): number {
  const { monthly, annual } = PLAN_LIST_PRICING_USD[plan];
  return Math.floor(((monthly.current - annual.current) / monthly.current) * 100);
}

/** Shown on upgrade prompts. Matches the public G2, Trustpilot and Capterra profiles. */
export const UPGRADE_SOCIAL_PROOF = {
  g2Rating: 5,
  trustpilotRating: 4,
  capterraRating: 4.6,
  customerCountLabel: '1,100+',
} as const;
